/**
 * Align app — /apps/align/*
 *
 * One job: a leadership team wants to see whether what they're doing maps to
 * what they said matters. Two screens (C Mode): The Map (objectives and the
 * work behind each) and The Gaps (unaligned work, unserved objectives).
 *
 * Respects the `strategy` workspace module — with Strategy off there are no
 * objectives to align to, so the app says so plainly rather than showing an
 * empty grid (absence, not a locked door).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import AlignMapScreen from './AlignMapScreen';
import AlignGapsScreen from './AlignGapsScreen';

export default function AlignApp() {
  const app = getAppDefinition('align')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<AlignMapScreen />} />
        <Route path="gaps" element={<AlignGapsScreen />} />
        <Route path="*" element={<Navigate to="/apps/align" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
